import React from "react";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import { Box, Button, Typography } from "@mui/material";

interface EmptyProps {
  message?: string; // Custom message to show
  onActionClick?: () => void; // Optional action button callback
  actionLabel?: string; // Label for the action button
}

const Empty: React.FC<EmptyProps> = ({
  message = "No data available",
  onActionClick,
  actionLabel = "Retry",
}) => {
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <SentimentDissatisfiedIcon
        color="disabled"
        fontSize="large"
        sx={{ mb: 2 }}
      />
      <Typography variant="h6" color="textSecondary" gutterBottom>
        {message}
      </Typography>
      {onActionClick && (
        <Button
          variant="contained"
          color="primary"
          onClick={onActionClick}
          sx={{ mt: 2 }}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

export default Empty;
